/* eslint-disable no-shadow,consistent-return,no-param-reassign,no-unused-vars */
import apiJoana from '@/services/jApiJoana';

const state = {
  group_data_list: [],
  dataset_list: [],
  dataset_data: null,
  dataset_id: null,
  form_changed: false,
  record_changed: false,
};

const mutations = {
  setListGroupData(state, data) {
    state.group_data_list = data;
  },
  setListDataset(state, data) {
    state.dataset_list = data;
  },
  setDataset(state, data) {
    state.dataset_data = data;
    state.dataset_id = data.id;
  },
  dataCreated(state) {
    state.form_changed = !state.form_changed;
  },
  dataRecordCreated(state) {
    state.record_changed = !state.record_changed;
  },
};

const actions = {
  // Data Group
  async getListDataGroup({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiJoana.listDataGroup(data);
      commit('setListGroupData', res.data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListDataGroupAsync({ dispatch }, { reqData, callback }) {
    try {
      const resData = await apiJoana.listDataGroup(reqData);
      const res = resData.data ? resData.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
  },

  async createDataGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiJoana.createDataGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async updateDataGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiJoana.updateDataGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async deleteDataGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.deleteDataGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  // Data Dataset
  async getListDatasetByGroup({ commit, dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiJoana.listDatasetByGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      commit('setListDataset', res.data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async actionListDatasetByGroup({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiJoana.listDatasetByGroup(data);
      commit('setListDataset', res.data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListDatasetByGroupAsync({ dispatch }, { reqData, callback }) {
    try {
      const resData = await apiJoana.listDatasetByGroup(reqData);
      const res = resData.data ? resData.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
  },

  async createDatasetByGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiJoana.createDatasetByGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async deleteDatasetByGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.deleteDatasetByGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataCreated');
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async truncateDatasetByGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.truncateDatasetByGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataCreated');
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getDetailDatasetByGroup({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiJoana.detailDatasetByGroup(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async addColumnDataset({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiJoana.addColumnDataset(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async updateColumnDataset({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiJoana.updateColumnDataset(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async deleteColumnDataset({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.deleteColumnDataset(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataCreated');
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async listRecordDataset({ dispatch }, data) {
    let res;
    try {
      res = await apiJoana.getListRecordByDatasetId(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async countRecordDataset({ dispatch }, data) {
    let res;
    try {
      res = await apiJoana.getCountRecordByDatasetId(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async createRecordDataset({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiJoana.createRecordDataset(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataRecordCreated');
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async updateRecordDataset({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiJoana.updateRecordDataset(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async deleteRecordDataset({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.deleteRecordDataset(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataRecordCreated');
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async listQuery({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.listQuery(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async runQuery({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.runQuery(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async createQuery({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.createQuery(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async updateQuery({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.updateQuery(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async deleteQuery({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.deleteQuery(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async saveResultQuery({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.saveResultQuery(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async setPrimaryKey({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.setPrimaryKey(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async removePrimaryKey({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.removePrimaryKey(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  // Indexes dataset
  async getIndexes({ dispatch }, data) {
    let res;
    try {
      res = await apiJoana.getIndexList(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async setIndexes({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.setIndexes(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async removeIndexes({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiJoana.removeIndexes(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getRequestOtpIndexes({ dispatch }, data) {
    let res;
    try {
      res = await apiJoana.getRequestOtp(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreJoana.js